// Service Worker Registration for VehicleBuddy PWA

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('✅ Service Worker registered:', registration);

          // When an updated SW takes control, reload the page once so the
          // user gets the latest build (fixes "site stuck / blank after deploy"
          // for users with an old cached service worker).
          let refreshing = false;
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (refreshing) return;
            refreshing = true;
            console.log('🔄 New Service Worker activated — reloading for latest build');
            window.location.reload();
          });

          // If a waiting SW is already installed, tell it to take over now.
          if (registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          }

          // Watch for future updates while the tab is open.
          registration.addEventListener('updatefound', () => {
            const installing = registration.installing;
            if (!installing) return;
            installing.addEventListener('statechange', () => {
              if (installing.state === 'installed' && navigator.serviceWorker.controller) {
                // New SW is ready but an old one still controls the page.
                installing.postMessage({ type: 'SKIP_WAITING' });
              }
            });
          });

          // Check for updates periodically
          setInterval(() => {
            registration.update().catch(() => null);
          }, 60000); // Check every minute
        })
        .catch((error) => {
          console.error('❌ Service Worker registration failed:', error);
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('❌ Service Worker unregistration failed:', error);
      });
  }
}

// Request notification permission (for future use)
export async function requestNotificationPermission() {
  if ('Notification' in window && 'serviceWorker' in navigator) {
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      console.log('✅ Notification permission granted');
      return true;
    } else {
      console.log('❌ Notification permission denied');
      return false;
    }
  }
  return false;
}

// Check if app is installed (PWA)
export function isInstalled() {
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }
  
  if (window.navigator.standalone === true) {
    return true; // iOS
  }
  
  return false;
}

// Show install prompt
let deferredPrompt;

export function setupInstallPrompt() {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    console.log('💾 Install prompt ready');
    
    // Dispatch custom event so components can show install button
    window.dispatchEvent(new CustomEvent('app-installable'));
  });
  
  window.addEventListener('appinstalled', () => {
    console.log('✅ VehicleBuddy installed!');
    deferredPrompt = null;
  });
}

export async function showInstallPrompt() {
  if (!deferredPrompt) {
    console.log('❌ Install prompt not available');
    return false;
  }
  
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  
  console.log(`User choice: ${outcome}`);
  deferredPrompt = null;
  
  return outcome === 'accepted';
}
